
import { computed, defineComponent, onMounted, ref } from "vue";

export default defineComponent({
	inheritAttrs: false,
	props: {
		name: String,
		modelValue: String,
		hasError: {
			type: Boolean,
			required: false,
		},
		valid: {
			type: Boolean,
			required: false,
		},
		errors: {
			type: Array,
			required: false,
		},
		label: {
			type: String,
			required: false,
		},
		placeholder: {
			type: String,
			required: false,
		},
		disabled: {
			type: Boolean,
			required: false,
		},
		type: {
			type: String,
			default: "text",
		},
	},
	setup(props, { emit }) {
		const inputValue = computed({
			get(): string {
				return props.modelValue ?? "";
			},
			set(value: string) {
				emit("update:modelValue", value);
			},
		});

		const active = ref(false);

		const onFocus = () => {
			active.value = true;
		};

		const onBlur = () => {
			if (inputValue.value.length < 1) {
				active.value = false;
			} else {
				active.value = true;
			}
		};

		onMounted(() => {
			onBlur();
		});

		return {
			active,
			inputValue,
			onFocus,
			onBlur,
		};
	},
});
